import {atomWithStorage} from "jotai/utils";
import {MRT_VisibilityState} from "material-react-table";

const LOCAL_STORAGE_ADMIN_FIELD_CHANGES_TABLE_COLUMNS_VISIBILITY_KEY = "adminFieldChangesTableColumnsVisibility";
const LOCAL_STORAGE_ADMIN_FIELD_CHANGES_TABLE_COLUMNS_SIZE_KEY = "adminFieldChangesTableColumnsSize";

const DEFAULT_ADMIN_FIELD_CHANGES_TABLE_COLUMN_VISIBILITY: MRT_VisibilityState = {
    actions: true,
    fieldId: true,
    username: true,
    company: true,
    name: true,
    changeDate: true,
};

export const adminFieldChangesTableColumnsVisibilityAtom = atomWithStorage<MRT_VisibilityState>(
    LOCAL_STORAGE_ADMIN_FIELD_CHANGES_TABLE_COLUMNS_VISIBILITY_KEY,
    DEFAULT_ADMIN_FIELD_CHANGES_TABLE_COLUMN_VISIBILITY,
);

export const adminFieldChangesTableColumnsSizeAtom = atomWithStorage<Record<string, number> | undefined>(
    LOCAL_STORAGE_ADMIN_FIELD_CHANGES_TABLE_COLUMNS_SIZE_KEY,
    undefined,
);
